import { UserState } from './user.reducers';
export const isAuthenticated = (state: UserState) => state.authenticated;
export const getAuthenticatedEmployee = (state: UserState) => {
  if (state.employee) {
    return state.employee;
  }
};
export const getRedirectedUrl = (state: UserState) => {
  if (state.redirectedUrl) {
    return state.redirectedUrl;
  }
};
